module.exports = __webpack_public_path__ + "static/media/Stellar Ora Queen Headboard - 155 cm_Charcoal.5360e73b.png";